import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { SearchService } from "@app/services/search.service";
import { ISearchScope, SearchController } from "@app/views/search.view";
import { INotification, ISavedSearch, meta } from "@models";
import { icons } from "@tools";

export interface INotificationsScope extends ISearchScope<INotification> {
    fixUrl: (url: string) => string;
}

@NgView({
    token: Token.NotificationsView,
    inherit: [Token.SearchView]
})
export class NotificationsController extends SearchController<INotification> {
    constructor(
        $scope: INotificationsScope,
        agg: SearchService
    ) {

        super(
            $scope,
            agg
        );

        $scope.allowSearch = false;
        agg.drawerService.pageTitle = loc.notifications;
        agg.drawerService.pageIcon = icons.email;

        agg.drawerService.setHelpUrl("Notifications");
    }

    public client(api: ApiService) {
        return api.notifications;
    }

    public newSearch(): ISavedSearch {
        return {
            modelType: meta.Notification.$name,
            sortField: "createdDate",
            descending: true,
            filters: this.getFiltersFromMeta(meta.Notification.$name, true),
            roles: []
        };
    }
}
